import {setNestedValue} from "@Common/utils/arr-path";

// inputData is not mutated
export const setInputData = async (product, inputData = {}) => {
    let productModel = await product.getProductModel();

    // add the surface list to the input data
    if (productModel._surfaces?.length) {
        inputData["surfaces"] = Array.from(productModel._surfaces).map(surface => surface["_name"]);
    }

    // add all items to the input data
    let items = await productModel.getAllItems();
    items.forEach(item => {
        let itemSurface = item["_parentContainer"]["parentComponent"]["_name"];
        if(item.type === "BoundedTextItem" || item.type === "PathBoundedTextItem" || item._text){
            inputData = setNestedValue(inputData, ['text', itemSurface, item._name], item._text);
        }
    });

    return inputData;

};
